import { getStaffList } from "api/staff";
import CustomReactSelect from "components/CustomReactSelect";
import PropTypes from "prop-types";
import { useEffect } from "react";
import useGlobalStore from "store/useGlobalStore";

const StaffSelector = ({
    value,
    onChange,
    label = "Users",
    placeholder = "Select users...",
    isMulti = false,
    required = false,
    disabled = false,
    filterByRole = null,
    ...props
}) => {
    const { staffs, setStaffs } = useGlobalStore();

    useEffect(() => {
        if (staffs.length === 0) {
            handleStaffsFetch();
        }
    }, []);

    const handleStaffsFetch = async () => {
        try {
            const response = await getStaffList({ get_all: true });
            const data = response.data?.data ?? [];
            const dataOptions = data.map(user => ({
                label: `${user.full_name} (${user.role?.name})`,
                value: user.id,
                roleId: user.role?.id
            }));
            setStaffs(dataOptions);
            return dataOptions;
        } catch (error) {
            return [];
        }
    };

    const getSelectedValue = () => {
        if (!value) return null;
        if (isMulti) {
            return staffs.filter(option => value.includes(option.value)) || null;
        }
        return staffs.find(option => option.value === value) || null;
    };

    const handleChange = (selectedOption) => {
        if (isMulti) {
            const selectedValues = selectedOption ? selectedOption.map(opt => opt.value) : [];
            if (onChange) {
                onChange(selectedValues, selectedOption);
            }
        } else {
            const selectedValue = selectedOption ? selectedOption.value : null;
            if (onChange) {
                onChange(selectedValue, selectedOption);
            }
        }
    };


    return (
        <CustomReactSelect
            label={label}
            isMulti={isMulti}
            isSearchable
            isClearable
            cacheOptions={false}
            loadOptions={handleStaffsFetch}
            value={getSelectedValue()}
            options={
                Array.isArray(filterByRole)
                    ? staffs.filter(option => filterByRole.includes(option.roleId))
                    : filterByRole
                        ? staffs.filter(option => option.roleId === filterByRole)
                        : staffs
            }
            onChange={handleChange}
            placeholder={placeholder}
            required={required}
            disabled={disabled}
            noOptionsMessage={() => "No staff found"}
            {...props}
        />
    );
};

StaffSelector.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
        PropTypes.string,
        PropTypes.number,
    ]),
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    isMulti: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    filterByRole: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.array
    ]),
};

export default StaffSelector;